// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3Zbe8","footer":"ModalInfo_footer__DI7H8"};